import { withStyles } from '@material-ui/core';

import PrimaryDetails from './component';
import styles from './styles';

export default withStyles(styles)(PrimaryDetails);
